import { Box, Image, Text, Button } from '@bonanza-social/moonlight';
import { memo, useCallback } from 'react';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';

function EmptyCategoryMessage() {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const onPress = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.navigate('MainTabNavigator', { screen: 'Games' });
    }
  }, [navigation]);

  return (
    <Box
      flex={1}
      alignItems="center"
      justifyContent="center"
      gap="space-400"
      paddingHorizontal="space-600"
    >
      <Image name="games.noFavorites" width={80} height={80} />
      <Text
        variant="h5"
        color="level_9"
        locNS="games"
        locKey="nothingInFavoritesTitle"
      />
      <Text
        variant="body-m"
        color="level_9"
        locNS="games"
        locKey="nothingInFavoritesSubTitle"
        textAlign="center"
      />
      <Button
        variant="primary"
        onPress={onPress}
        locNS="common"
        locKey="goBack"
        size="large"
        width={{
          desktop: 'auto',
          tablet: '100%',
          mobile: '100%',
        }}
      />
    </Box>
  );
}

export default memo(EmptyCategoryMessage);
